import type { AnchorHTMLAttributes, Ref } from 'react';
import clsx from 'clsx';
import './BrandLogo.css';

export interface BrandLogoProps extends Omit<AnchorHTMLAttributes<HTMLAnchorElement>, 'children'> {
  /** Link destination. Defaults to the marketing site. */
  href?: string;
  /** Logo image source. Defaults to the canonical brand-tile asset. */
  src?: string;
  ref?: Ref<HTMLAnchorElement>;
}

/**
 * BrandLogo — the fluent.ge wordmark rendered as a link.
 *
 * Used on standalone screens that sit outside the app shell (auth, check-email,
 * password reset). Encapsulates the `<a><img></a>` markup so feature code never
 * hand-rolls a raw anchor. The intrinsic 440×159 image attributes are kept for
 * layout stability (CLS); the rendered height is controlled by CSS so callers
 * can size it via their own class (e.g. `auth-card__brand`).
 */
export function BrandLogo({
  href = 'https://fluent.ge',
  src = '/character/fluent-logo-tile.png',
  className,
  ...rest
}: BrandLogoProps) {
  return (
    <a className={clsx('fluent-brand-logo', className)} href={href} aria-label="fluent.ge" {...rest}>
      <img src={src} alt="fluent" width={440} height={159} />
    </a>
  );
}
